import { createStyles, Theme } from '@material-ui/core/styles';
import { Manrope } from '../../constants/theme';

/**
 *
 * @param {Theme} theme Material Theam.
 * @returns {Theme} Return Material theams.
 */
const Styles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			justifyContent: 'space-around',
			marginTop: '4%'
			
		},
		tab: {
			fontSize: `14 !important`,
			fontWeight: 500,
			maxWidth: '100% !important',
			color: '#05713B'
		},
		tabDisabled: {
			cursor: 'not-allowed !important',
			'pointer-events': 'visible !important'
		},
		selected: {
			backgroundColor: 'rgba(4, 109, 57, 0.05)'
		},
		categoryContainer: {
			[theme.breakpoints.down('sm')]: {
				display: 'none'
			}
		},
		hr: {
			backgroundColor: '#046D39 !important',
			opacity: 0.3
		},
		gridSpacing: {
			padding: theme.spacing(1.5),
			[theme.breakpoints.down('sm')]: {
				padding: theme.spacing(0.5)
			}
		},
		footer: {
			position:'absolute',
			bottom:theme.spacing(4),
			fontFamily: Manrope,
			color: '#84818A',
			textAlign: 'center',
			fontWeight: 500,
			fontSize: theme.spacing(1.5)
		}
	});

export default Styles;
